// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../configs';
import useAuthStore from './auth';

const BASE_TOUR = [
  {
    header: 'Welcome, Let\'s Take a Tour!',
    message: 'Thank you for registering. Let\'s get set up and see some results. But first, let us show you a few things.',
    nextUrl: '/reporting',
  },
  {
    header: 'Reporting',
    message: 'Here you will find the information about your customers. There isn’t any information yet, but once you are all set up, this is where the good stuff is.',
    nextUrl: '/dashboard',
  },
  {
    header: 'Your Dashboard',
    message: 'With our Capture upgrade you can download your customer’s information and use it to remarket back to them.',
    nextUrl: '/forms',
  },
  {
    header: 'Your Forms',
    message: 'This page is where you tell us which forms you want to us to track. You can add as many as you like, but start with at least one so we can watch them for you and Capture any leads from your website that were lost. If you need help, click the chat button below.',
    nextUrl: '/setup',
  },
  {
    header: 'Your Simple Capture Setup',
    message: 'Follow these steps to install our snippet on your website to start collecting data. *If you are creating an account through WiX or Shopify, you can ignore step 1.',
    nextUrl: '/faq',
  },
  {
    header: 'FAQ',
    message: 'If you have any questions, check our FAQs for more information or contact us so we can assist you to the best of our ability. You can also email us at info@automatedremarketing.com.',
    nextUrl: '/setup',
  },
];

const SHOPIFY_SUPPLEMENT = [
  { header: 'Integrations', message: 'Since this account has been created through a Shopify integration, let\'s take a look at the integration.', nextUrl: '/integrations' },
  { header: 'Shopify Integration', message: 'Clicking on the integrations tab will give you a list of our integration partners. Clicking on Shopify will show you more details.', nextUrl: '/integrations/Shopify/Setup' },
  { header: 'Plan Selection', message: 'From here, you can click the Integration Pricing sub tab and select a plan that\'s right for you.', nextUrl: '/integrations/Shopify/IntegrationPricing' },
  { header: 'Plan Selection', message: 'Unsure which plan is right for you? Contact us @ info@automatedremarketing.com.', nextUrl: '/integrations/Shopify/IntegrationPricing' },
];

const useTourStore = create((set, get) => ({
  tourIndex: 0,
  tourArray: BASE_TOUR.slice(),

  displayTour: () => useAuthStore.getState().user.displayTour || false,
  currentTour: () => {
    const { tourArray, tourIndex } = get();
    return tourArray.length <= tourIndex ? false : tourArray[tourIndex];
  },

  appendShopify: () => set((s) => ({ tourArray: [...s.tourArray, ...SHOPIFY_SUPPLEMENT] })),

  reset: () => {
    useAuthStore.setState((s) => ({ user: { ...s.user, displayTour: false } }));
    set({ tourIndex: 0 });
  },
  nextStep: () => set((s) => ({ tourIndex: s.tourIndex + 1 })),
  backStep: () => set((s) => ({ tourIndex: s.tourIndex === 0 ? 0 : s.tourIndex - 1 })),
  endTour: () => {
    useAuthStore.setState((s) => ({ user: { ...s.user, displayTour: false } }));
    axios.post(`${API_URL}/api/um/disableTour`);
  },
}));

export default useTourStore;
